export const SITE_URL = "https://www.theqahub.es";
export const BRAND_NAME = "TheQAHub";
export const PERSON_NAME = "Diego Sanchez Martin";

export const absoluteUrl = (value) => {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("//")) return `https:${value}`;
  return `${SITE_URL}${value.startsWith("/") ? "" : "/"}${value}`;
};

export const plainText = (value = "") => (
  value
    .replace(/<[^>]*>/g, " ")
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/\s+/g, " ")
    .trim()
);

export const schemaGraph = (nodes) => ({
  "@context": "https://schema.org",
  "@graph": nodes.filter(Boolean),
});

export const organizationSchema = (logoUrl) => ({
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: BRAND_NAME,
  url: SITE_URL,
  logo: absoluteUrl(logoUrl),
  founder: {
    "@type": "Person",
    name: PERSON_NAME,
    url: `${SITE_URL}/sobre-mi`,
  },
  sameAs: [
    "https://www.youtube.com/@theqahub_es",
    "https://www.twitch.tv/theqahub",
    "https://github.com/theqahub",
    "https://www.linkedin.com/in/diegosanchezmartin/",
    "https://www.instagram.com/theqahub_es/",
    "https://x.com/theqahub",
  ],
  description: "Plataforma educativa sobre Quality Assurance, testing y automatizacion de software.",
});

export const webSiteSchema = () => ({
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: BRAND_NAME,
  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },
  inLanguage: ["es", "en", "de"],
});

export const breadcrumbSchema = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: absoluteUrl(item.url),
  })),
});

export const blogSchema = () => ({
  "@type": "Blog",
  "@id": `${SITE_URL}/blog#blog`,
  name: "Blog de TheQAHub",
  url: `${SITE_URL}/blog`,
  description: "Articulos, guias y recursos sobre QA, testing y automatizacion.",
  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },
  inLanguage: "es",
});

export const blogPostingSchema = ({ id, title, summary, content, image, date }) => ({
  "@type": "BlogPosting",
  "@id": `${SITE_URL}/blog/${id}#article`,
  mainEntityOfPage: `${SITE_URL}/blog/${id}`,
  headline: title,
  description: plainText(summary || content).slice(0, 300),
  image: absoluteUrl(image),
  datePublished: date,
  dateModified: date,
  author: {
    "@type": "Person",
    name: PERSON_NAME,
    url: `${SITE_URL}/sobre-mi`,
  },
  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },
  inLanguage: "es",
});

export const courseListSchema = (courses) => ({
  "@type": "ItemList",
  "@id": `${SITE_URL}/aprende#courses`,
  name: "Cursos de TheQAHub Academy",
  itemListElement: courses.map((course, index) => ({
    "@type": "ListItem",
    position: index + 1,
    item: courseSchema(course),
  })),
});

export const courseSchema = (course) => ({
  "@type": "Course",
  "@id": `${SITE_URL}/learn/${course.id}#course`,
  name: course.title,
  description: `Curso de ${course.title} para aprender QA y automatizacion con una serie guiada de ${course.videos.length} videos.`,
  url: `${SITE_URL}/learn/${course.id}`,
  provider: {
    "@id": `${SITE_URL}/#organization`,
  },
  educationalLevel: course.level,
  hasCourseInstance: {
    "@type": "CourseInstance",
    courseMode: "online",
    courseWorkload: `PT${Math.max(course.videos.length, 1)}H`,
  },
  hasPart: course.videos.map((video) => ({
    "@type": "CreativeWork",
    name: video.title,
    url: video.watchUrl,
  })),
});
